import { FC, Suspense, useEffect } from "react";
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {Curriculum} from '../../education/curriculum/List'
import {CurriculumDetail} from '../../education/curriculum/Detail'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {HomeworkList} from '../../education/homework/List'
import {StudentList} from '../../education/student/List'
import {StudentAdd} from '../../education/student/StudentAdd'
import {ClassShare} from '../../education/student/ClassShare'
import {HomeworkCreate} from '../../education/homework/Create'
import {HomeworkDetail} from '../../education/homework/Detail'
import {ClassDashboard} from '../../education/dashboard/ClassDashboard'
import {Profile} from '../../education/profile/Profile'
import {Settings} from '../../education/profile/Settings'
import {ActivityLibrary} from '../../education/activity/ActivityLibrary'
import {ActivityDetail} from '../../education/activity/ActivityDetail'
import { WithChildren } from "../../_metronic/helpers";
import { globalDataCache } from "../../services/helper/re-cache";

const PrivateRoutes = () => {

  useEffect(() => {
    globalDataCache()
  }, []);
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='activities' element={<SuspendedView><ActivityLibrary/></SuspendedView>}/>
        <Route path='activities/:id' element={<SuspendedView><ActivityDetail/></SuspendedView>}/>
        <Route
          path='auth/*'
          element={
            <SuspendedView>
              <Navigate to='/' />
            </SuspendedView>
          }
        />
          <Route
              path='profile/'
              element={
                  <SuspendedView>
                      <Profile />
                  </SuspendedView>
              }
          />
          <Route
              path='profile/settings'
              element={
                  <SuspendedView>
                      <Settings />
                  </SuspendedView>
              }
          />
        <Route
          path='/dashboard'
          element={
            <SuspendedView>
              <ClassDashboard />
            </SuspendedView>
          }
        />
        <Route
          path='curriculum'
          element={
            <SuspendedView>
              <Curriculum />
            </SuspendedView>
          }
        />
        <Route
          path='curriculum/:id'
          element={
            <SuspendedView>
              <CurriculumDetail />
            </SuspendedView>
          }
        />
        <Route
          path='student'
          element={
            <SuspendedView>
              <StudentList />
            </SuspendedView>
          }
        />
        <Route
          path='student/add'
          element={
            <SuspendedView>
              <StudentAdd />
            </SuspendedView>
          }
        />
        <Route
          path='classroom/share'
          element={
            <SuspendedView>
              <ClassShare />
            </SuspendedView>
          }
        />
        <Route
          path='homework'
          element={
            <SuspendedView>
              <HomeworkList />
            </SuspendedView>
          }
        />
        <Route
          path='homework/create'
          element={
            <SuspendedView>
              <HomeworkCreate />
            </SuspendedView>
          }
        />
        <Route
          path='homework/:id'
          element={
            <SuspendedView>
              <HomeworkDetail />
            </SuspendedView>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspendedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
